// extracted by mini-css-extract-plugin
export var button = "_fb-0";
export var donut = "_fb-1";
export var donutFill = "_fb-3";
export var donutTrack = "_fb-2";